<template>
    <FormSection
        title="Patient Notes"
        :full-height="false"
        :application-id="application"
        :popoverContent="popoverContent"
    >
        <template #content>
            <section class="d-flex flex-column px-4 py-2">
                <div class="form-group col-12 offset-md-1 col-md-10 my-4" slot="content">
                    <textarea
                        class="form-control"
                        id="patient-notes"
                        rows="4"
                        placeholder="Enter Patient Notes"
                        v-model="patientDetails.patientNotes.note"
                        :maxlength="200"
                    ></textarea>
                    <p class="mb-0">You have 200 remaining characters.</p>
                </div>
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./PatientNotes.ts"></script>
